import React, { useState } from "react";
import { Snackbar, Alert, Slide, Grid, Box, Typography } from "@mui/material";
import Portal from "@mui/base/Portal";

export const Nodata = (props: any) => {
  const { type } = props;
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "50vh" }}
    >
      <Grid item xs={3}>
        <Box>
          <Typography
            style={{
              color: "#96a4b7",
              fontSize: 15,
              fontStyle: "italic",
              fontWeight: 300,
            }}
          >
            No {type}s found. To get started, Click on <b>"Add New {type}".</b>
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};
